<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Staff List</h2>
        </div>
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                  <div class="tabs flex space-x-4 border-2 mb-4">
                    <button
                      v-for="tab in tabs"
                      :key="tab.id"
                      @click="selectTab(tab.id)"
                      :class="{
                        'border-b-4 border-danger text-danger': selectedTab === tab.id,
                        'bg-gray-500 text-white': selectedTab !== tab.id
                      }"
                       
                      class="py-2 px-4 font-medium"
                    >
                      {{ tab.name }}
                    </button>
                  </div>
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Full Name</th>
                                    <!-- <th class="bg-[#B2E8D9]">Last Name</th> -->
                                    <th class="bg-[#B2E8D9]">Contact</th>
                                    <th class="bg-[#B2E8D9]">Address</th>
                                    <th class="bg-[#B2E8D9]">Gender</th>
                                    
                                    <th class="bg-[#B2E8D9]">City</th>
                                    <th class="bg-[#B2E8D9]">Date Of Joining</th>
                                    <th class="bg-[#B2E8D9]">Date Of Leaving</th>
                                    <th class="px-3.5 py-4">Action</th>
                                    <!-- <th class="bg-[#B2E8D9]">Set Rate</th>
                                    <th class="bg-[#B2E8D9]">Set Quantity</th> 
                                    <th class="bg-[#B2E8D9]">Stock </th> 
                                    <th class="bg-[#B2E8D9]">Stock Value</th>  -->
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in filteredStaffList" :key="item.id">
                                    <td @click="selectStaff(item.id)">{{item.firstname}} {{item.lastname}}</td>
                                    <!-- <td>{{item.lastname}}</td> -->
                                    <td>{{item.phonenumber}}</td>
                                    <td>{{item.address}}</td>
                                    <td>{{item.gender}}</td>
                                    <td>{{item.city}}</td>
                                    <td> {{ getOnlyDate(item.dateofjoining+"") }}</td>
                                    <td> {{ getOnlyDate(item.dateofleaving+"") }}</td>

                                    

                                  
                                    <td class="px-3.5 py-4">
                                        <div class="flex items-center gap-1">
                                          <button class="btn-primary"  @click="editStaff(item.id)"  v-show="userRole === '1'">
                                            <i class="ri-edit-2-line text-inherit text-[13px]"></i>Edit
                                        </button>
                                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" v-show="userRole === '1'">
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>
           
                                            <button class="btn-icon btn-primary-icon-light size-7" @click="navigateToPrintPage(item.id)" >
                                              <i class="ri-printer-line text-primary text-[13px]"></i>
                                          </button>
                                            <!-- <button class="btn-icon btn-danger-icon-light size-7" @click="addfollowup(item)">
                                                <i class="ri-edit-2-line text-inherit text-[13px]"></i>  -->
                                                <!-- Change the icon here -->
                                            <!-- </button> -->


                                        </div>
                                    </td>



                                <!--<td>{{item.prate}}</td>
                                    <td>{{item.salerate}}</td>
                                    <td>{{item.set_rate}}</td>
                                    <td>{{item.set_qty}}</td> 
                                    <td>{{item.stock}}</td> 
                                    <td>{{parseFloat(item.prate)*parseFloat(item.stock)}}</td>  -->
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->


    <!-- start add follow up model -->

  
    <div id="addfollowup" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
          <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
              <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            <div class="p-4 md:p-5">
              
                <div class="mt-7">
                    <label for="tagname" class="form-label">Lead Name *</label>
                    <input type="text" v-model="lead.name" class="form-input" id="first_input" placeholder="Lead Name" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Contact *</label>
                    <input type="number" v-model="lead.contact" class="form-input" id="first_input" placeholder="Contact" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Address *</label>
                    <input type="text" v-model="lead.address" class="form-input" id="first_input" placeholder="Address" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Gender *</label>
                    <input type="text" v-model="lead.gender" class="form-input" id="first_input" placeholder="Gender" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Age *</label>
                    <input type="number" v-model="lead.age" class="form-input" id="first_input" placeholder="Age" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Next Date *</label>
                    <input type="date" v-model="lead.nextdate" class="form-input" id="first_input" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Remark *</label>
                    <input type="text" v-model="lead.remark" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
                  </div>
      
              
      
              <div class="flex justify-end mt-7">
                <button @click="save_package" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      











     <!-- end add follow up model -->







    
  <!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
    <div class="p-4 w-full max-w-lg max-h-full">
      <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
        <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
          <i class="ri-close-line text-inherit text-xl leading-none"></i>
        </button>
        <div class="p-4 md:p-5">
          

           <!-- start show data ---------------------------------------------------------------------------------------->
            <!-- start table here -->
      <div class="p-4 md:p-5">
        <table class="min-w-full table-auto">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Entry Date</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Remark</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Next Date</th>
            </tr>
          </thead>
          <tbody>
             <tr v-for="item in followup_list" :key="item.id" class="bg-white"> 
              
              <!-- <tr v-for="(item ,index)  in leadlists" :key="item.id"> -->
              <td class="px-4 py-2 text-sm text-gray-900">{{item.iddate}}</td>
              <td class="px-4 py-2 text-sm text-gray-900">{{item.remark}}</td>
              <td class="px-4 py-2 text-sm text-gray-900">{{item.nextdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- end table -->

            <!-- end show data --------------------------------------------------------------------------------------------------->



          <div class="mt-7">
            <label for="tagname" class="form-label">Next Date *</label>
            <input type="date" v-model="leads.nextdate" class="form-input" id="first_input" autocomplete="off" required>
          </div>
  
          <div class="mt-7">
            <label for="tagname" class="form-label">Remark *</label>
            <input type="text" v-model="leads.remark" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
          </div>
  
          <div class="flex justify-end mt-7">
            <button @click="save_followup" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Edit Modal -->
  










    
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted(){
 this.getBasics();
},
data() {
 return {
     isAdd:0,
     selectedTab: 'all',
     isEdit:0,
     tabs:[],
     isDelete: 0,
     deleteId: 0,
     filteredStaffList:[],
     productsList:[],
     leadlist:[],
     stafflist:[],
     userRole:localStorage.getItem('userRole'),
     leadlists:[],
     datatable:null,
     followup_list:[],
    //  product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
    //  employees: {empname:'',emprole:'0',isMainAdmin:0},

    staff:{
        firstname:'',
        lastname:'',
        phonenumber:'',
        address:'',
        gender:'',
        city:'',
        dateofjoining:'',
        dateofleaving:'',
    },


    leads:{
        nextdate:'',
        remark:'',
        lead_id:0,

    },

    selected_leadid:0,


    lead: { 
                
                name: '', 
                contact:'',
                address:'',
                gender:'',
                age:'',
                nextdate:'',
                remark:'',

            
            },
 }
 }, 
 computed: {
  filteredStaffList() {
    const selectedTab = this.tabs.find(tab => tab.id === this.selectedTab);

    if (selectedTab && selectedTab.id === 'all') {
      return this.stafflist;
    }
    
    // If no tab is selected, return all staff
    if (!selectedTab) {
      return this.stafflist;
    }

    // Log selectedTab and its ID
    console.log('Selected Tab:', selectedTab);

    // Filter staff based on the selected tab's service_id
    return this.stafflist.filter(staff => {
      // Ensure staff.service_id is a string before splitting
      const staffServiceIds = staff.service_id ? staff.service_id.split(',').map(Number) : [];

      // Log staff and their service_ids
      console.log('Staff:', staff.name, 'Service IDs:', staffServiceIds);
      
      // Check if the selectedTab.id exists in the staff's service_id list
      return staffServiceIds.includes(Number(selectedTab.id));
    });
  }
}
,
methods:{
  editStaff(id)
  {
        this.$router.push({ name: 'addstaff', query: { id: id } });
  },
  getOnlyDate(date){
    
    try {
    if(date){
      var dateHere=date;
      return dateHere.split(' ')[0];
    }else
    return '';
      
    } catch (error) {
      alert(error);
    return '';
    }
    
  },
  selectStaff(staffid) {
      // Store the staffid in localStorage (or sessionStorage if preferred)
      localStorage.setItem('selectedStaffId', staffid);
      // Redirect to service subscription list or update the data as needed
      this.$router.push({ name: 'servicesubscription' });  // If you use Vue Router
    },
  selectTab(key) {
      // console.log('Tab selected:', key);
      this.selectedTab = key;
    },
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
        
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
      var self = this; 
        this.leads.lead_id=item.id;
        axios.post('getleadbyid',{leadeid:item.id}).then(function (response) {
                  self.followup_list=response.data.followup_list;
                  console.log(self.followup_list);
                  self.employees=response.data.userDetails;
                }).then(()=>{ 
                    // self.datatable= $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false });
              
                    });;

                 


     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },


 save_package() {
             var self = this; 
             axios.post('addlead', this.lead)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                    //  self.packageList=response.data.packages;
                    //  self.employees=response.data.userDetails;
                     self.getBasics();
                     self.closeModal();
                    //  self.cat={name:'',status:'Active'};

                     //self.$swal(msg);
                    //  if (isSuccess == 1) {
                    //      self.closeModal();
                    //  }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },

         save_followup() {
             var self = this; 
             axios.post('addfollowup', this.leads)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                    //  self.packageList=response.data.packages;
                    //  self.employees=response.data.userDetails;
                     self.getBasics();
                     self.closeModal();
                    //  self.cat={name:'',status:'Active'};

                     //self.$swal(msg);
                    //  if (isSuccess == 1) {
                    //      self.closeModal();
                    //  }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },




 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getstafflist').then(function (response) {
                  self.stafflist=response.data.staff;
                  //self.tabs=response.data.services;
                  // self.tabs.push(response.data.services);
                  self.tabs = [{ id: 'all', name: 'All' }, ...response.data.services];
                  self.employees=response.data.userDetails;
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false,
                            dom: 'Bfrtip', 
                            buttons: [
                              {
                                extend: 'excelHtml5',
                                title: 'Excel',
                              },
                            ],  
                          });
              
                    });;
  }, 

 
  navigateToPrintPage(staffId) {
    const url = `${window.location.origin}/#/staffinvoice?id=${staffId}`;
    const newWindow = window.open(url, '_blank');
    
    // Ensure the new tab is opened before triggering print
    if (newWindow) {
      newWindow.focus();
    } else {
      alert("Popup blocked. Please allow popups for this site.");
    }
  },


  // async getBasicsfollowup() {
  //      var self=this;
  //        axios.post('getLeadListfollowup').then(function (response) {
  //                 self.leadlists=response.data.leads;
  //                 self.employees=response.data.userDetails;
  //               });
  // }, 

 






// async getBasics() {
//             var self = this;
//             axios.post('getLeadList').then(function (response) {
//                  self.catList = response.data.cats;
//                  self.employees = response.data.userDetails;
//             });
//         },

            delete_category() {
                var self = this; 
                axios.post('deletestaff', {deleteId:this.deleteId})
                    .then(response => {
                        self.stafflist=response.data.staff;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                         //self.fetchStaffList();
                         location.reload();
                        
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
}
}
</script>
